import { createContext } from 'react'
import { SingleContext, defaultSingleContext } from './SingleContext.types'

export const singleContext = createContext<SingleContext>(defaultSingleContext)
